module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAdCAAAAACcOlPtAAAAcUlEQVR4AWL4igcAyqVvAoZiKIqh/DHJ3Uh+twG8OT03lYFXnVVD4Zxqe4+tplmYIBwvOwIkYQW89PBAFe4eCO1uLQB+F9omfdhmwou6u97N3Uxo6017v9lq7yh9M6FUJpTKftGWi7rF/qOtJa8jPnQGBVHy1vOjr/4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/date-arrow.png
// module id = jcOM
// module chunks = 216